import React, { useState, useCallback, useRef } from "react";
import { createAppContainer} from 'react-navigation';
import { createStackNavigator } from 'react-navigation-stack';


import Info from './info';
import Infoo from './infoo';
import Main from './main';
import Terms from './terms';
import Main2 from './main2';
import Main3 from './main3';
import Clemazon from './clemazon';
import Clemazon1 from './clemazon1';
import Clemazon1_2 from './clemazon1_2';
import Clemazon2 from './clemazon2';
import Clemflix2 from './clemflix2';
import Clemflix1 from './clemflix1';
import Clemflix1_2 from './clemflix1_2';
import Clemflix from './clemflix';
import Clemscholar from './clemscholar';
import Clemscholar1 from './clemscholar1';
import Clemscholar1_2 from './clemscholar1_2';
import Clemscholar2 from './clemscholar2';
import Last from './last';
const AppNavigator = createStackNavigator(
  {  

    Info: {screen: Info},
    Infoo: Infoo,
    Terms:Terms,
    Main: Main,
    Main2: Main2,
    Main3: Main3,
    Clemazon:Clemazon,
    Clemazon1:Clemazon1,
    Clemazon1_2:Clemazon1_2,
    Clemazon2:Clemazon2,
    Clemflix:Clemflix,
    Clemflix1:Clemflix1,
    Clemflix1_2:Clemflix1_2,
    Clemflix2:Clemflix2,
    Clemscholar:Clemscholar,
    Clemscholar1:Clemscholar1,
    Clemscholar1_2:Clemscholar1_2,
    Clemscholar2:Clemscholar2,
    Last:Last,
  
  },
  {
    /* The header config from HomeScreen is now here */
    defaultNavigationOptions: {
      headerShown: false 
    },
  }
);
const AppContainer = createAppContainer(AppNavigator);

export default AppContainer;

